// Zero-based index range of the page links to show: `visiblePages` links whenever there are that
// many pages, with the current page kept near the middle and the range clamped to the first/last page.
export function pageLinkWindow(currentPage, maxPage, visiblePages) {
    const currentIndex = Math.max(currentPage - 1, 0);
    const maxIndex = Math.max(maxPage - 1, 0);
    const half = Math.floor(visiblePages / 2);
    let min = Math.max(currentIndex - half, 0);
    const max = Math.min(min + visiblePages - 1, maxIndex);
    min = Math.max(max - visiblePages + 1, 0);
    return { min: min, max: max };
}
